import { useTranslation } from 'react-i18next'
import { VirtualBadgeCard } from '@/components/virtual-badge'
import { useScreenWakeLock } from '@/hooks/use-screen-wake-lock'

// Rota dedicada para atalho na tela inicial do celular
export const VirtualBadgePage = () => {
	const { t } = useTranslation()
	useScreenWakeLock(true)

	return (
		<div className="flex flex-col items-center gap-4 px-4 py-6">
			<div className="text-center">
				<h1 className="font-bold text-kaefer-dark-grey text-xl">
					{t('virtualBadge.title')}
				</h1>
				<p className="text-muted-foreground text-sm">
					{t('virtualBadge.description')}
				</p>
			</div>
			<VirtualBadgeCard />
		</div>
	)
}
